import { apiClient, makeServicePlugin, BaseModel } from '@/api'

class ApiKeys extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'ApiKeys'
  // Define default properties here
  static instanceDefaults() {
    return {
      user_id: null,
      api_key: null,
      bot_id: null,
      role_id: null,
      public_map: false
    }
  }
}

const servicePath = 'api-keys'
const servicePlugin = makeServicePlugin({
  Model: ApiKeys,
  service: apiClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
apiClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin